type FlashMessagePropsType = Readonly<{
  message: string;
  type?: string;
  title: string;
}>;

const FlashMessage = ({ title, message }: FlashMessagePropsType) => {
  return (
    <div className="flash-message">
      <div className="flash-message__title">{title}</div>
      <div className="flash-message__title">{message}</div>
    </div>
  );
};

export default FlashMessage;
